<section>
  <app-mini-env-banner [slides]="bannerSlides" (butonAction)="onSliderBtnAction()"></app-mini-env-banner>
</section>


<section class="container-fluid discount-section">
  <div class="container">

    <app-mini-env-heading-block [miniTitle]="'Benefits Overview'"
      [title]="'Up to 80% discount on your healthcare needs!'"
      [description]="'Get massive savings on doctor visits, labs, and prescriptions with a single, affordable membership..'"
      [style]="'max-width: 703px;'" [discription]="'max-width: 600px;'"></app-mini-env-heading-block>

    <div class="row" style="row-gap: 15px;margin-top: 30px;">
      <div *ngFor="let item of services" class="col-md-3 col-12 discount-col">
        <app-mini-env-info-card class="perfectpizzapie" [icon1]="sharedService.imagesUrl + item.icon"
          [icon2]="sharedService.imagesUrl + 'free-icon.png'" [title]="item.title" [description]="item.description"
          [isFree]="item.isFree" [enableRouter]="false">
        </app-mini-env-info-card>
      </div>
    </div>
  </div>
</section>

<section id="membership-section" class="container-fluid membershipplans-section membership-section">
  <div class="container">
    <div class="row basic-section-gap" style="flex-direction: row;">
      <div class="col-md-12">
        <app-mini-env-heading-block class="whata-burger-plane" [miniTitle]="'Affordable Healthcare solution for you!'"
          [title]="'Healthcare access with membership,no insurance needed'"
          [style]="'max-width: 684px;'"></app-mini-env-heading-block>
      </div>
      <div class="col-md-12">
        <app-membership-plan class="whata-burger-plane"
          [label]="('MEMBERSHIP.LABEL' | translateIt: {language: sharedService.currentLanguage} | async)"
          [note1]="('MEMBERSHIP.NOTE1' | translateIt: {language: sharedService.currentLanguage} | async)"
          [note2]="('MEMBERSHIP.NOTE2' | translateIt: {language: sharedService.currentLanguage} | async)"
          [note3]="('MEMBERSHIP.NOTE3' | translateIt: {language: sharedService.currentLanguage} | async)"
          [membershipPlanCode]="membershipPlanCode" [btnLabel]="'Select Membership'"></app-membership-plan>
      </div>

    </div>
  </div>
</section>
<section class="health-share">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-6 col-md-6">
        <app-mini-env-heading-block class="medical-expences"
          [miniTitle]="('BENIFITSMEMBERSHIP.MEDICQAL' | translateIt: {language: sharedService.currentLanguage} | async)"
          [title]="'Healthshare Covers Large Medical Expenses at Lower Prices'"
          [description]="'Healthshare helps you manage major medical expenses more affordably.  By pooling monthly contributions from members, the community assists with costs such as ER visits, surgeries, and hospital stays, providing support at a fraction of typical health insurance prices.'"
          [style]="'max-width: 520px;'"></app-mini-env-heading-block>
        <img src="/assets/tenant-assets/mini-env/images/medical-expeness.png" class="medical-expencive img-fluid"
          alt="Medical Expenses">
        <button class="btn btn-primary payment-btn" [routerLink]="['/health-sharing']"
          routerLinkActive="router-link-active" style="width: 250px; padding: 15px;">Learn More</button>
      </div>
      <div class="col-lg-6 col-md-6 d-flex justify-content-end">
        <div class="medical-img">
          <img src="/assets/tenant-assets/mini-env/images/perfect-piza-healthshare.png" class="health-share-img img-fluid"
            alt="Medical Expenses">
        </div>
      </div>
    </div>
  </div>
</section>
<section class="container-fluid bg-white avail-benefits">

  <app-mini-env-heading-block
    [miniTitle]="('BENIFITSMEMBERSHIP.MINI_TITLE' | translateIt: {language: sharedService.currentLanguage} | async)"
    [title]="'Getting Started to Avail Your WoW Benefits Is Super Easy!'"
    [description]="'Follow these simple steps to start your WoW Health journey today.'"
    [style]="'max-width: 738px;'"></app-mini-env-heading-block>

  <app-imagebox-bullet-scroll
    [imgLink]="sharedService.imagesUrl + 'woman-wave-phone.webp'"></app-imagebox-bullet-scroll>
</section>




<section class="container-fluid faq-section">
  <div class="container">

    <app-mini-env-heading-block [miniTitle]="'FAQs'" [title]="'Frequently Asked Questions'"
      [description]="'Some questions you might have in your mind. If you couldnt find yours, call us anytime at 844-969-4325'"
      [style]="'max-width: 684px;'"></app-mini-env-heading-block>

    <div class="mt-30">
      <app-mini-env-faqs [faqData]="faqList"></app-mini-env-faqs>
    </div>
  </div>
</section>

<section class="container-fluid footer-section">
  <app-mini-env-sub-footer></app-mini-env-sub-footer>
</section>
<!--  How can we help Section End-->